// react-snap loads every route in a headless Chrome with a fixed user-agent
// ("ReactSnap") at build time. Third-party scripts (analytics, tag manager,
// etc.) have no business running during that prerender pass: they fire network
// requests that skipThirdPartyRequests aborts (the net::ERR_FAILED noise) and
// can keep a page from ever reaching networkidle0, causing navigation timeouts
// that abort the whole build. Gate that init behind this flag.
export const isPrerender =
  typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
